import PropTypes from 'prop-types';
import { ActionIcon, Tooltip } from '@mantine/core';
import { CircularProgress, makeStyles } from '@material-ui/core';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import cx from 'classnames';

const useStyles = makeStyles((theme) => ({
  hideIconIcon: {
    position: 'absolute',
    opacity: 0,
    transition: 'opacity 0.3s ease-out',
  },
  showIconIcon: {
    opacity: 1,
    transition: 'opacity 0.3s ease-out',
  },
  doneIcon: {
    height: 24,
    color: theme.colors.green,
  },
  errorIcon: {
    height: 24,
    color: theme.palette.error.main,
  },
}));

const BaseMenuItem = ({
                        icon,
                        title,
                        label,
                        onClick,
                        isLoading,
                        isSuccess,
                        isFailed,
                        isDisabled,
                        buttonAlign,
                      }) => {
  const classes = useStyles();

  return <Tooltip label={label} position='top' disabled={!label}>
    <ActionIcon style={{ height: 34, width: 'auto', justifyContent: buttonAlign }}
                onClick={onClick}
                disabled={isDisabled}>
      {!isLoading && !isSuccess && !isFailed && icon}
      <CircularProgress
        color={'primary'}
        size={20}
        className={cx(
          classes.hideIconIcon, {
            [classes.showIconIcon]: isLoading,
          })}
      />
      <CheckCircleOutlineOutlinedIcon className={cx(
        classes.hideIconIcon,
        classes.doneIcon, {
          [classes.showIconIcon]: isSuccess,
        })} />
      <ErrorOutlineIcon className={cx(
        classes.hideIconIcon,
        classes.errorIcon, {
          [classes.showIconIcon]: isFailed,
        })}
      />
      {title}
    </ActionIcon>
  </Tooltip>;
};

BaseMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isFailed: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default BaseMenuItem;
